import {api} from '../../utils/api'
import store from "../store";

export default {
    /**
     * get all tasks
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    loadList({commit}) {
        return api.call(commit, 'get', process.env.VUE_APP_NOTIFICATIONS_URL + '/api/notifications', null, 'SET_NOTIFICATIONS');
    },

    /**
     * Read notification
     * @param commit
     * @param task_id
     * @param type
     * @param external_id
     * @param payload
     * @returns {Promise<any>}
     */
    read({ commit }, {task_id, type, external_id}) {

        // Get current user id
        const uid = store.getters['auth/currentUser'].id;

        // Delete notifications
        return api.call(commit, 'delete', process.env.VUE_APP_NOTIFICATIONS_URL + `/api/notifications/${task_id}/users/${uid}/${type}/${external_id}`, false, 'DELETE_NOTIFICATIONS');
    },

    /**
     * Unread notification
     * @param commit
     * @param task_id
     * @param type
     * @param external_id
     * @param info
     * @param payload
     * @returns {Promise<any>}
     */
    unread({ commit }, {task_id, type, external_id}) {

        // Get current user id
        const uid = store.getters['auth/currentUser'].id;

        // Create notifications
        return api.call(commit, 'get', process.env.VUE_APP_NOTIFICATIONS_URL + `/api/notifications/${task_id}/users/${uid}/${type}/${external_id}`, false, 'DELETE_NOTIFICATIONS');
    },
    notificationSettingsList({commit}) {
        return api.call(commit, 'get', process.env.VUE_APP_NOTIFICATIONS_URL + `/api/user-notification/list/`, false, 'SET_NOTIFICATION_SETTINGS_LIST');
    },
    updateNotificationSettings({commit}, payload) {
        return api.call(commit, 'post', process.env.VUE_APP_NOTIFICATIONS_URL + `/api/user-notification/update/`, payload, 'SET_NOTIFICATION_SETTINGS_LIST');
    }
}
